<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() | translate }}</h3>
    </div>
  </div>
  <div
    style="max-height: 70vh !important; min-height: 400px !important"
    class="card-body scroll"
    [perfectScrollbar]="{ wheelPropagation: false }"
  >
    <form [formGroup]="form" class="form form-group mb-0">
      <div *ngIf="!hasKeys" class="alert alert-custom alert-light-danger fade show px-6 py-2 mb-10">
        <div class="alert-icon">
          <i style="font-size: 1.6rem !important" class="flaticon-warning"></i>
        </div>
        <div class="alert-text">Template keys should be added!</div>
        <div class="alert-close">
          <button type="button" class="close" data-dismiss="alert">
            <i class="ki ki-close"></i>
          </button>
        </div>
      </div>
      <div class="file-input mb-6" (click)="clickFileInput($event, fileInput)">
        <div>
          <mat-form-field appearance="fill">
            <mat-label>{{ 'FORMS_TEMPLATES_MODULE.TEMPLATE.FILE' | translate }}</mat-label>
            <input matInput required readonly type="text" formControlName="name" />
            <input
              #fileInput
              required
              hidden
              type="file"
              accept=".odt"
              (change)="changeFile($event)"
            />
            <mat-hint>Accepted file type .odt</mat-hint>
            <mat-error *ngIf="isInvalid('file', 'required')">{{
              getErrorMessage('FORMS_TEMPLATES_MODULE.TEMPLATE.FILE' | translate, 'required')
            }}</mat-error>
            <mat-error *ngIf="isInvalid('name', 'pattern')">{{
              getErrorMessage('FORMS_TEMPLATES_MODULE.TEMPLATE.FILE' | translate, 'pattern')
            }}</mat-error>
          </mat-form-field>
        </div>
        <span
          *ngIf="!data.viewMode"
          matTooltip="{{ 'TABLE.ATTACH' | translate }} File"
          class="btn btn-icon btn-light-primary btn-hover-primary"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/attachment.svg"
            class="svg-icon svg-icon-lg svg-icon-primary"
          ></span>
        </span>
        <button
          *ngIf="data.viewMode"
          matTooltip="{{ 'TABLE.DOWNLOAD' | translate }} File"
          class="btn btn-icon btn-light-primary btn-hover-primary"
          (click)="downloadFile($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/Files/Download.svg"
            class="svg-icon svg-icon-lg svg-icon-primary"
          ></span>
        </button>
      </div>
      <div>
        <label
          *ngIf="!data.viewMode"
          style="padding-left: 0.75em !important"
          class="font-weight-bolder mb-4"
          >Keys <span [class.text-danger]="!hasKeys">*</span></label
        >
        <div *ngIf="!data.viewMode" class="d-flex mb-4">
          <div class="flex-grow-1 d-flex align-items-stretch">
            <div class="w-50">
              <mat-form-field appearance="fill">
                <mat-label>Key</mat-label>
                <input #key matInput type="text" />
              </mat-form-field>
            </div>
            <div class="w-50 ml-4">
              <mat-form-field appearance="fill">
                <mat-label>Default Value</mat-label>
                <input #value matInput type="text" />
              </mat-form-field>
            </div>
          </div>
          <div
            [matTooltip]="
              !key.value ? 'Add Key!' : ((keyIndex ? 'TABLE.UPDATE' : 'TABLE.ADD') | translate)
            "
            [matTooltipPosition]="'above'"
          >
            <button
              [disabled]="!key.value"
              class="btn btn-icon btn-light btn-hover-success btn-sm ml-4"
              (click)="addEditKey($event)"
            >
              <span
                [inlineSVG]="
                  keyIndex
                    ? 'assets/media/svg/icons/General/edit_icon.svg'
                    : 'assets/media/svg/icons/Navigation/Plus.svg'
                "
                class="svg-icon svg-icon-md svg-icon-success"
              ></span>
            </button>
          </div>
        </div>
        <div>
          <div
            class="d-flex align-items-stretch border border-secondary rounded font-weight-bold p-2 mb-2"
          >
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">Key</div>
              <div class="w-50 px-2">Default Value</div>
            </div>
            <div *ngIf="!data.viewMode" style="width: 85px !important" class="px-2">Actions</div>
          </div>
          <div>
            <div
              *ngIf="!keys.length"
              style="height: 80px !important"
              class="d-flex flex-center font-weight-bold"
            >
              No Key-Value Pairs Found!
            </div>
            <div
              *ngFor="let k of keys; let idx = index"
              class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1"
            >
              <div class="flex-grow-1 d-flex align-items-center">
                <div class="w-50 px-2">{{ k.key }}</div>
                <div class="w-50 px-2">{{ k.value }}</div>
              </div>
              <div *ngIf="!data.viewMode" style="width: 85px !important" class="px-2">
                <button
                  [matTooltip]="'TABLE.UPDATE' | translate"
                  class="btn btn-icon btn-light btn-hover-primary btn-sm"
                  (click)="prepareEditKey($event, idx)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-primary"
                  ></span>
                </button>
                <button
                  [matTooltip]="'TABLE.DELETE' | translate"
                  class="btn btn-icon btn-light btn-hover-danger btn-sm ml-2"
                  (click)="deleteKey($event, idx)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                    class="svg-icon svg-icon-md svg-icon-danger"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      *ngIf="!data.viewMode"
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
